import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
    mutation userProfileMutation($input: EditPersonalProfileInput!) {
        editPersonalProfile(input: $input) {
            user {
                profile {
                    firstName
                    lastName
                    zipCode
                    currency
                    measurementUnit
                }
            }
        }
    }
`;

export function userProfileMutation(environment, args) {
    const {
        firstName,
        lastName,
        userServiceId,
        zipCode,
        currency,
        measurementUnit,
        onCompleted,
        onError,
    } = args;
    commitMutation(environment, {
        mutation,
        variables: {
            input: {
                firstName,
                lastName,
                userServiceId,
                zipCode,
                currency,
                measurementUnit,
            },
        },
        onCompleted,
        onError,
    });
}
